import React, { useEffect, useRef, useState } from "react";
import { Col, Row, Collapse } from "antd";
import { useDispatch, useSelector } from "react-redux";
import { AppDispatch, RootState } from "../../../../apis/store";
import { getProofDocuments } from "../../../../apis/actions/recipient.actions";
import PaginationComponent from "../../../../biblio/Pagination/PaginationComponent";
import { scroll, toFilterData } from "../../../../components/utils/utils";
import { FileAddOutlined } from "@ant-design/icons";
import PdfPreview from "../../../../biblio/Modal/PdfPreview";
import DotsLoader from "../../../../biblio/Loader/DotsLoader";
import dayjs from "dayjs";
const ProofDocumentsPage = ({ state }: any) => {
  const dispatch = useDispatch<AppDispatch>();
  const [currentPage, setCurrentPage] = useState(1);
  const itemsPerPage = 9;
  const [pdfUrl, setPdfUrl] = useState<string>("");
  const [FilteredProofListRequest, setFilteredProofListRequest] = useState<
    any[]
  >([]);
  const { data: proofDocumentsList, loading } = useSelector(
    (state: RootState) => state?.recipient?.proofDocuments
  );

  const currentRef = useRef<HTMLDivElement>(null);

  const updateActive = (nb: number) => {
    setCurrentPage(nb);
    scroll(currentRef);
  };
  useEffect(() => {
    setCurrentPage(1);
    setFilteredProofListRequest(
      toFilterData(proofDocumentsList?.member_documents, state)
    );
  }, [state, proofDocumentsList]);
  useEffect(() => {
    dispatch(getProofDocuments());
  }, [dispatch]);
  const handleDownloadOrPreview = (doc: { url: string; name: string }) => {
    setPdfUrl(doc.url);
  };

  const paginatedDocuments = FilteredProofListRequest?.slice(
    (currentPage - 1) * itemsPerPage,
    currentPage * itemsPerPage
  );

  return (
    <>
      {loading ? (
        <div
          className="takaful--loading-projects-cases"
          style={{ marginTop: "5rem" }}
        >
          <p className="takaful--no-project-message"> جارٍ التحميل</p>
          <DotsLoader />
        </div>
      ) : proofDocumentsList?.member_documents?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد أوراق ثبوتية
        </p>
      ) : FilteredProofListRequest?.length === 0 ? (
        <p className="takaful--no-services" style={{ marginTop: "5rem" }}>
          لا توجد أوراق ثبوتية تتوافق مع البحث الذي قمت به
        </p>
      ) : (
        <>
          <div
            className="takaful--collapse-profile-container"
            style={{ marginTop: "2rem" }}
          >
            <div
              className={`takaful--collapse-profile takaful--collapse-label-container takaful--collapse-beneficiary-services `}
            ></div>
            <Collapse
              className={`takaful--collapse-profile takaful--collapse-beneficiary-services takaful--collapse-sponsor-requests`}
              accordion={false}
              activeKey={[]}
            >
              {paginatedDocuments?.map((member: any, memberIndex: number) => (
                <React.Fragment key={memberIndex}>
                  <div
                    style={{
                      direction: "rtl",
                      display: "flex",
                      marginRight: "1rem",
                    }}
                  >
                    <p className="takaful--content-services-request-p">
                      إسم المستفيد :
                    </p>
                    <span
                      className="takaful--content-services-request-span"
                      style={{ marginRight: "0.2rem" }}
                    >
                      {member.partner_name}
                    </span>
                  </div>
                  {member.documents?.map((doc: any, docIndex: number) => (
                    <Collapse.Panel
                      key={`${memberIndex}-${docIndex}`}
                      className="takaful--header-profile-Panel takaful--collapse-label-panel"
                      showArrow={false}
                      header={
                        <div className="takaful--header-profile-container">
                          <Row
                            gutter={16}
                            align={"middle"}
                            className="takaful--content-profile-box1"
                            style={{ marginBottom: "0" }}
                          >
                            <Col
                              xxl={4}
                              xl={4}
                              lg={4}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <p className="takaful--content-services-request-p">
                                إسم المرفق :
                              </p>
                            </Col>
                            <Col
                              xxl={6}
                              xl={6}
                              lg={6}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <span className="takaful--content-services-request-span">
                                {doc.name}
                              </span>
                            </Col>
                            <Col
                              xxl={4}
                              xl={4}
                              lg={4}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <p className="takaful--content-services-request-p">
                                تاريخ الإضافة :
                              </p>
                            </Col>
                            <Col
                              xxl={4}
                              xl={4}
                              lg={4}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <span className="takaful--content-services-request-span takaful--color-span">
                                {doc?.create_date
                                  ? dayjs(
                                      doc?.create_date,
                                      "YYYY-MM-DD"
                                    ).format("YYYY/MM/DD")
                                  : ""}
                              </span>
                            </Col>
                            <Col
                              xxl={3}
                              xl={3}
                              lg={3}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <p className="takaful--content-services-request-p">
                                المرفق :
                              </p>
                            </Col>
                            <Col
                              xxl={2}
                              xl={2}
                              lg={2}
                              md={6}
                              sm={12}
                              xs={24}
                              className="takaful--content-profile-col"
                            >
                              <FileAddOutlined
                                className="takaful--download-icon takaful--service-download-icon"
                                onClick={(e) => {
                                  e.stopPropagation();
                                  handleDownloadOrPreview(doc);
                                }}
                              />
                            </Col>
                          </Row>
                        </div>
                      }
                    ></Collapse.Panel>
                  ))}
                </React.Fragment>
              ))}
            </Collapse>
          </div>

          <div className="takaful--pagination-container">
            {FilteredProofListRequest &&
              FilteredProofListRequest.length > itemsPerPage && (
                <PaginationComponent
                  active={currentPage}
                  total={proofDocumentsList?.length}
                  itemPerPage={itemsPerPage}
                  scroll={() => scroll(currentRef)}
                  setActive={(nb) => updateActive(nb)}
                  showLess={true}
                />
              )}
          </div>
        </>
      )}
      <PdfPreview
        open={pdfUrl !== ""}
        onClose={() => setPdfUrl("")}
        url={pdfUrl}
        isBlob={false}
        className="takaful--pdf-preview-modal"
      />
    </>
  );
};

export default ProofDocumentsPage;
